fccd-location-information {
  .spacer-xxs {
    margin-bottom: var(--spacing-xxs);
  }

  a {
    color: var(--color-link-base);

    &:visited {
      color: var(--color-primary-base);
    }
  }
}
